import {QuestionStatus} from '@cp/model';
import {QuestionFormData} from '../../../types/QuestionFormData';

/**
 * Create initial empty QuestionFormData
 */
export default function createEmptyQuestionData(providedModuleId?: string): QuestionFormData {
  return {
    moduleId: providedModuleId || '',
    questionText: '',
    hint: '',
    options: ['', '', '', ''],
    answer: '',
    explanation: '',
    topic: '',
    difficulty: 1,
    statusNote: '',
    status: QuestionStatus.GENERATED,
    feedbackPositive: 0,
    feedbackNegative: 0,
    image: null,
    graphJson: '',
  };
}
